// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StylesGuideOl {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.StylesGuideOl span {
  font-size: 25px;
  font-weight: 600;
  letter-spacing: 1px;
}
.StylesGuideOl ol {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.StylesGuideOl ol li {
  font-size: 15px;
  letter-spacing: 0.3px;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/StylesGuide/Lists/OL/OL.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AAAI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAER;AAAI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAER;AADQ;EACI,eAAA;EACA,qBAAA;AAGZ","sourcesContent":[".StylesGuideOl {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    span {\n        font-size: 25px;\n        font-weight: 600;\n        letter-spacing: 1px;\n    }\n    ol {\n        display: flex;\n        flex-direction: column;\n        gap: 15px;\n        li {\n            font-size: 15px;\n            letter-spacing: 0.3px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
